import { itemListingMapper } from '~/mappers/itemListing';
import { ItemListing } from '~/mappers/itemListing/models';

import { L3ItemListing } from './models';

const l3ItemListingMapper = (
  l3ItemListing: ItemListing | L3ItemListing,
  currentPageUid: string
) => {
  const { itemListingCarousel, l3CarouselExtension } =
    l3ItemListing as L3ItemListing;
  const isCrossSellVariant = l3CarouselExtension?.[0]?.variant === 'cross sell';
  const isUpSellVariant = l3CarouselExtension?.[0]?.variant === 'up sell';
  const { items } = itemListingCarousel?.[0]?.items[0] || {};

  if (isCrossSellVariant) {
    const { ui } = itemListingCarousel[0].carousel[0];
    const { isOrderReversed } = l3CarouselExtension[0];

    itemListingCarousel[0].items[0].items = items.map((item) => ({
      ...item,
      shopifyBlock: null,
      ...(isOrderReversed && {
        className: 'cds-card--with-reverse-order',
      }),
    }));

    itemListingCarousel[0].carousel[0].ui = {
      ...ui,
      ...(isOrderReversed && {
        className: 'cds-carousel--with-reverse-order',
      }),
    };

    itemListingCarousel[0].items[0] = {
      ...itemListingCarousel[0].items[0],
      descriptionField: '',
    };
  }

  if (isUpSellVariant) {
    const {
      addToCartButton,
      pricesUI: [{ currentPriceUI, discountedPriceUI }],
    } = l3CarouselExtension[0];

    itemListingCarousel[0].items[0].items = items.map((item) => {
      const {
        addToCartButton: {
          text,
          iconPrefix,
          iconSuffix,
          disabled,
          storefrontId,
        },
      } = item.shopifyBlock[0];

      return {
        ...item,
        shopifyBlock: [
          {
            ...item.shopifyBlock[0],
            isUpSellVariant,
            buyNowButton: null,
            ...(addToCartButton && {
              addToCartButton: {
                ...addToCartButton,
                text,
                iconPrefix,
                iconSuffix,
                disabled,
                storefrontId,
              },
            }),
            ...(currentPriceUI && {
              currentPriceUI,
            }),
            ...(discountedPriceUI && {
              discountedPriceUI,
            }),
          },
        ],
        className: 'cds-card--up-sell',
      };
    });

    itemListingCarousel[0].items[0] = {
      ...itemListingCarousel[0].items[0],
      showCategory: true,
    };
  }

  return itemListingMapper(
    itemListingCarousel?.[0] || l3ItemListing,
    currentPageUid
  );
};

export { l3ItemListingMapper };
